import z from "zod";
import { trackedCustomProductSchema, trackedPageDataSchema } from "../utils";
import { pushGtmEvent } from "./utils";

export const selectItemEventInputSchema = z.object({
  product: trackedCustomProductSchema,
  currency: z.string(),
  pageData: trackedPageDataSchema.nullish(),
});

export type SelectItemEventInput = z.infer<typeof selectItemEventInputSchema>;

export const selectItemEventPayloadSchema = z
  .object({
    event: z.literal("select_item"),
    ecommerce: z.object({
      item_list_id: z.string().nullish(),
      item_list_name: z.string().nullish(),
      items: z.array(
        z.object({
          item_id: z.string(),
          item_name: z.string(),
          currency: z.string(),
          item_brand: z.string().optional(),
          item_category: z.string().optional(),
          item_category2: z.string().optional(),
          item_category3: z.string().optional(),
          item_list_id: z.string().nullish(),
          item_list_name: z.string().nullish(),
          price: z.number(),
        }),
      ),
    }),
  })
  .optional();

export type SelectItemEventPayload = z.infer<
  typeof selectItemEventPayloadSchema
>;

export function buildSelectItemEventPayload(input: SelectItemEventInput) {
  const data = selectItemEventInputSchema.parse(input);

  if (!data) {
    return;
  }

  return selectItemEventPayloadSchema.parse({
    event: "select_item",
    ecommerce: {
      item_list_id: data.pageData?.id,
      item_list_name: data.pageData?.title,
      items: [
        {
          item_id: data.product.item_id,
          item_name: data.product.item_name,
          currency: data.currency,
          item_brand: data.product.item_brand,
          item_category: data.product.item_category,
          item_category2: data.product.item_category2,
          item_category3: data.product.item_category3,
          item_list_id: data.pageData?.id,
          item_list_name: data.pageData?.title,
          price: data.product.price,
        },
      ],
    },
  });
}

export function selectItemEvent(props: SelectItemEventInput) {
  if (typeof window === "undefined") {
    return;
  }

  if (!props.product) {
    return;
  }

  try {
    const payload = buildSelectItemEventPayload({
      product: props.product,
      currency: props.currency,
      pageData: props.pageData,
    });
    pushGtmEvent(payload);
  } catch {}
}
